export default {
    listagem: {
        titulo_pagina: 'Lista de Escala',
        novo: 'Criar nova Escala',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        table: {
            empty: 'Nenhuma Escala encontrado',
            nome: 'Nome',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar nova Escala',
            editar: 'Editar Escala'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código da Escala'
            },
            nome: {
                label: 'Nome',
                description: 'Nome da Escala'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo da Escala'
            },
            botao_salvar : 'Salvar Escala'
        },
        create: {
            success: 'Escala criada com Sucesso!',
            error: 'Error ao criar Escala!'
        },
        update: {
            success: 'Escala editada com Sucesso!',
            error: 'Error ao editar Escala!'
        }
    }
}
